import React from 'react'
import useSearch from '../../../context/search/useSearch'

interface SearchResultsArticlesPageProps {
  dataSet: DOMStringMap
}


const SearchResultsArticlesPage: React.FC<SearchResultsArticlesPageProps> = () => {

  const { activeTab, searchResultsArticles, searchTerm } = useSearch()

  if (activeTab !== 'blogs') {
    return null
  }

  const articles = searchResultsArticles ?? []

  // Parse menu data from data attributes




  return (
    <div className={'search search__results search__results--list search__results--articles tab'}>


      <div className={'search__results-list search__results-list--articles'}>
        {articles.length > 0 ? (
          <ul>
            {articles.map((article, index) => (
              <li className={'search__results-item search__results-item--articles'} key={index}>
                <a className='search__results-item-image' href={article.url}>
                  <img src={article.image} alt={article.title} />
                </a>
                <a className='search__results-item-title' href={article.url} data-ticket={article.ticket ?? ''}>{article.title}</a>
              </li>
            ))}
          </ul>
        ) : (
          <div className="search__results-no-results">
            <p>Sorry we couldn&lsquo;t find &quot;{searchTerm}&quot;</p>
            <p>Try adjusting your search or get in touch:</p>
            <div className="search__results-no-results-buttons">
              <a className="btn-b-to-w btn--large" href="/contact-us">Contact Us</a>
              <a className="btn-2 btn--secondary btn--large" href="/">Back Home</a>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchResultsArticlesPage
